import React from 'react';
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

const Column = ({ label, value = '-' }: { label: string; value?: string }) => {
  return (
    <Col xs={6} xl={4}>
      <h5 className="text-truncate">{label}</h5>
      <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>}>
        <p className="text-truncate">{value}</p>
      </OverlayTrigger>
    </Col>
  );
};

function RecruiterProfileInfoCard() {
  const user = useSelector((state: RootState) => state.user.user);

  return (
    <Card className="h-100">
      <Card.Body>
        <div className="border-bottom border-dashed mb-4">
          <h4 className="mb-3 lh-sm lh-xl-1">Account Information</h4>
        </div>
        <Row>
          <Column label="Contact Person Name" value={user.info.recruiterName} />
          <Column
            label="Contact Person Designation"
            value={user.info.recruiterDesignation}
          />
          <Column label="Contact Person Email" value={user.info.contactEmail} />
          <Column
            label="Contact Person Phonenumber"
            value={user.info.contactPhoneNumber}
          />
          <Column
            label="Address"
            value={
              typeof user.info.address === 'string' ? user.info.address : ''
            }
          />
        </Row>
      </Card.Body>
    </Card>
  );
}

export default RecruiterProfileInfoCard;
